module.exports = __webpack_public_path__ + "static/media/elDesafio.6fc100db.webp";